module.exports = __webpack_public_path__ + "ffe4d6015cf79bcf53acbe6fb898aaf2.svg";